module.exports = __webpack_public_path__ + "img/bri.2a605c47.png";